<template>
  <v-container fluid>

    <!-- Page Title -->
    <app-page-title
      v-bind:title="'App Settings'"
      v-bind:icon="'settings'"
    />

    <!-- Page Loading -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :color="appColor_Progress"
    />

    <v-list class="pt-0">
      <v-list-item>
        <v-list-item-content class="pt-1">
          <!-- Sale Day Mode -->
          <v-switch
            v-model="isSaleDayMode"
            value
            :color="appColor_Selected"
            @change="enableSaleDayMode"
            :disabled="isSaving"
            hide-details
            :loading="isLoading"
            class="ml-3"
            >
            <span slot="label" class="grey--text text--darken-3 font-weight-bold ml-1">
              Sale Day Mode
            </span>
          </v-switch>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" max-width="400px">
      <app-error
        :error-title="errorTitle"
        :error-text="errorText"
        @close="errorDialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import AppPageTitle from '@/components/AppPageTitle'
import { mapGetters } from 'vuex'
import { AppColor } from '@/config.js'
import AppError from '@/components/AppError'

export default {
  name: 'AppSettings',
  components: {
    AppPageTitle,
    AppError
  },
  data () {
    return {
      appColor_Progress: AppColor.Progress,
      appColor_Selected: AppColor.Selected,
      isLoading: true,
      isSaving: false,

      // settings
      isSaleDayMode: false,

      // error handling
      errorDialog: false,
      errorTitle: 'Internal Error',
      errorText: null
    }
  },
  computed: {
    ...mapGetters(['appSettings'])
  },
  methods: {
    loadData () {
      if (this.appSettings === undefined || typeof this.appSettings === 'undefined') return

      const self = this
      self.isLoading = true
      appService.getAppSettings(this.appSettings.saleDayRuleId).then(data => {
        if (data.errSeverity > 0) {
          self.errorText = data.errorMessage
          self.errorDialog = true
        } else {
          self.isSaleDayMode = data.appSettings.isSaleDayMode
        }
        self.isLoading = false
      })
    },

    enableSaleDayMode () {
      const self = this
      self.isSaving = true
      appService.enableSaleDayMode(self.appSettings.saleDayRuleId, self.isSaleDayMode).then((data) => {
        if (data.errSeverity > 0) {
          self.errorText = data.errorMessage
          self.errorDialog = true
        } else {
          const isSaleDayMode = self.isSaleDayMode
          self.$store.dispatch('updateSaleDayMode', { isSaleDayMode })
        }
        self.isSaving = false
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>
